exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-02d6a5a5]{width:320px}.table[data-v-02d6a5a5]{margin-top:20px}.text-truncate[data-v-02d6a5a5]{display:inline-block;max-width:100%;cursor:pointer}.text-truncate[data-v-02d6a5a5]:hover{color:#409eff}", ""]);

// exports
